/**
 * Labstep
 *
 * @module components/JupyterNotebook/Modal/Automation
 * @desc JupyterNotebook Modal to setup automation
 */

import { JupyterNotebookFormShowEditAutomation } from 'labstep-web/components/JupyterNotebook/Form/ShowEdit/Automation';
import { ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as ModalDefault } from 'labstep-web/core/Modal/Default';
import { humanReadableDate } from 'labstep-web/services/date.service';
import type React from 'react';
import type { JupyterNotebookModalAutomationProps } from './types';

export const JupyterNotebookModalAutomation: React.FC<
  JupyterNotebookModalAutomationProps
> = ({ jupyterNotebook }) => (
  <ModalDefault
    header="Automation"
    content={() => (
      <JupyterNotebookFormShowEditAutomation
        jupyterNotebook={jupyterNotebook}
      />
    )}
    viewComponent={({ toggleModal }) => (
      <ActionComponent
        type="icon"
        icon="time"
        elementProps={{
          color: jupyterNotebook.automation ? 'orange' : 'grey',
          popup: {
            content: `${jupyterNotebook.automationDisplay} ${
              jupyterNotebook.automation?.trigger_at
                ? ` - Next run scheduled: ${humanReadableDate(
                    jupyterNotebook.automation.trigger_at,
                  )}`
                : ''
            }`,
          },
        }}
        onClick={toggleModal}
      />
    )}
  />
);
